import React, { useCallback } from 'react';

import {
    useSelector,
    selectMode,
    selectTitle,
    selectDescription,
    useDispatch,
    updateTitle,
    updateDescription,
    updateDescriptionCollapsed,
    selectLayoutGlobalOptions,
    selectIsDescriptionCollapsed,
} from '@splunk/dashboard-state';
import { useFeatureFlags, useHeaderRef } from '@splunk/dashboard-context';

import { CommonHeader } from '../HeaderComponents';

export const ConnectedDashboardHeader = () => {
    const dispatch = useDispatch();
    const { showTitleDescriptionCollapseHandle = false } = useFeatureFlags();
    const mode = useSelector(selectMode);
    const title = useSelector(selectTitle);
    const description = useSelector(selectDescription);
    const isDescriptionCollapsed = useSelector(selectIsDescriptionCollapsed);
    const isExpanded = !isDescriptionCollapsed;
    const { showTitleAndDescription = true } = useSelector(
        selectLayoutGlobalOptions
    );
    const containerRef = useHeaderRef('container');
    const titleRef = useHeaderRef('title');
    const descRef = useHeaderRef('description');
    const handleRef = useHeaderRef('collapseHandle');

    const handleExpandToggle = useCallback(() => {
        dispatch(updateDescriptionCollapsed(!isDescriptionCollapsed));
    }, [dispatch, isDescriptionCollapsed]);

    const handleTitleCommit = useCallback(
        (val?: string) => dispatch(updateTitle(val)),
        [dispatch]
    );

    const handleDescriptionChange = useCallback(
        (value?: string) => dispatch(updateDescription(value)),
        [dispatch]
    );

    const valueTitle = title;
    const valueDesc = description;

    return (
        <CommonHeader
            ref={containerRef}
            descRef={descRef}
            descriptionValue={valueDesc}
            handleRef={handleRef}
            isExpanded={isExpanded}
            mode={mode}
            onDescriptionChange={handleDescriptionChange}
            onExpandToggle={handleExpandToggle}
            onTitleChange={handleTitleCommit}
            showCollapseHandle={showTitleDescriptionCollapseHandle}
            showHeader={showTitleAndDescription}
            titleRef={titleRef}
            titleValue={valueTitle}
        />
    );
};
